<template>
<div>
    OTHER
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>